export const SET_MCH = 'SET_MCH'
export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js